@if (this.rss.document) {
<div class="row align-items-baseline">
  <div class="col">
    <h3 class="mt-4">
      {{ this.documentFileName(this.rss.document.filename) }}
    </h3>
  </div>
  <div class="col-auto text-end">
    <app-skill-id-input
      [value]="this.rss.document.skillId"
      (changed)="this.rss.document.skillId = $event; this.saveDocument()"
    ></app-skill-id-input>
  </div>
  <div class="col-auto text-end pe-0">
    @if (!this.rss.document.mimetype.startsWith('image/')) {
    <p-toggleswitch
      [(ngModel)]="this.rss.document.enabledForKnowledge"
      (ngModelChange)="this.saveDocument()"
    ></p-toggleswitch>
    }
  </div>
</div>
@if (!this.rss.document.mimetype.startsWith('image/')) {
<p-divider
  align="left"
  styleClass="mt-4 mb-1"
>
  <span
    class="text-muted small fw-semibold"
    i18n="@@ki-recognition"
  >KI-Erkennung</span>
</p-divider>
<div class="row align-items-center mt-3">
  <div class="col-3">
    <span i18n="@@trigger">Auslöser</span>
  </div>
  <div class="col">
    <p-inputgroup>
      <p-inputgroup-addon>
        <i
          class="ri-sparkling-fill text-primary"
          style="font-size: 1.2rem;"
        ></i>
      </p-inputgroup-addon>
      <input
        pInputText
        type="text"
        i18n-placeholder="@@describe-if"
        placeholder="Beschreibe, wann die KI reagieren soll"
        [(ngModel)]="this.rss.document.description"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.saveDocument(true)"
        fluid
      >
    </p-inputgroup>
  </div>
</div>
}
<div class="row align-items-center mt-3">
  <div class="col-3">
    <span i18n="@@documents-publicly-reachable-label">Öffentlich erreichbar</span>
    <app-hint i18n="@@documents-publicly-reachable-detail-hint">
      Öffentlich erreichbare Dokumente können ohne Anmeldung heruntergeladen werden.
      Vergib zusätzlich eine Skill-ID, wenn du dafür einen einprägsamen öffentlichen Link möchtest.
    </app-hint>
  </div>
  <div class="col">
    <p-toggleswitch
      [(ngModel)]="this.rss.document.publiclyReachable"
      (onChange)="this.saveDocument()"
    ></p-toggleswitch>
  </div>
</div>
@if (this.rss.document.mimetype.startsWith('image/') && this.rss.document.publiclyReachable) {
<div class="mt-3">
  <img
    [src]="'/api/toolbox/bot/file/' + this.rss.botConfig._id + '/' + this.rss.document.skillId"
    [alt]="this.rss.document.filename"
    class="img-fluid w-100"
    style="border-radius: 4px;"
  />
</div>
}
@if (!this.rss.document.mimetype.startsWith('image/')) {
<div class="row mt-3 align-items-center">
  <div class="col-3">
    <span i18n="@@chunk-display-config-heading">KI-Metadaten</span>
    <app-hint i18n="@@chunk-display-config-hint">Wähle aus, welche zusätzlichen Metadaten zusammen mit dem
      Chunk-Inhalt an die KI weitergegeben werden.</app-hint>
  </div>
  <div class="col">
    <div class="d-flex flex-column gap-2">
      <div class="d-flex align-items-center gap-2">
        <p-toggleswitch
          [(ngModel)]="this.safeChunkDisplayConfig.showFilename"
          (ngModelChange)="this.saveDocument()"
        ></p-toggleswitch>
        <i class="ri-file-text-line"></i>
        <span i18n="@@chunk-show-filename">Dateiname</span>
      </div>
      <div class="d-flex align-items-center gap-2">
        <p-toggleswitch
          [(ngModel)]="this.safeChunkDisplayConfig.showPageNumber"
          (ngModelChange)="this.saveDocument()"
        ></p-toggleswitch>
        <i class="ri-pages-line"></i>
        <span i18n="@@chunk-show-page">Seitenzahl</span>
      </div>
      <div class="d-flex align-items-center gap-2">
        <p-toggleswitch
          [(ngModel)]="this.safeChunkDisplayConfig.showScore"
          (ngModelChange)="this.saveDocument()"
        ></p-toggleswitch>
        <i class="ri-percent-line"></i>
        <span i18n="@@chunk-show-score">Score</span>
      </div>
      <div class="d-flex align-items-center gap-2">
        <p-toggleswitch
          [(ngModel)]="this.safeChunkDisplayConfig.showChapter"
          (ngModelChange)="this.saveDocument()"
        ></p-toggleswitch>
        <i class="ri-list-check-2"></i>
        <span i18n="@@chunk-show-chapter">Kapitel</span>
      </div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-3">
    <span i18n="@@functionname">Funktionsname</span>
    <app-hint i18n="@@function-name-hint">
      Bitte wähle für deinen Skill einen sprechenden bzw. aussagekräftigen (Funktions)-Namen.
      Es sind max. <b>30 Zeichen</b> für einen Namen zulässig, sowie ausschließlich folgende Zeichen:
      <b>a-z</b>, <b>A-Z</b>, <b>0-9</b>, <b>-</b> und <b>_</b>.
    </app-hint>
  </div>
  <div class="col">
    <app-function-name-suggest
      [descriptionString]="this.rss.document.description"
      (finish)="this.rss.document.functionName = $event; this.saveDocument()"
      style="display: block; width: 100%;"
    >
      <input
        pInputText
        type="text"
        i18n-placeholder="@@name"
        placeholder="Name"
        maxlength="30"
        [(ngModel)]="this.rss.document.functionName"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.rss.checkFunctionName(this.rss.document.functionName) && this.saveDocument()"
        fluid
      />
    </app-function-name-suggest>
  </div>
</div>
<div class="row mt-3 align-items-center">
  <div class="col-3">
    <label
      class="form-label"
      i18n="@@doc-search-type"
    >Suchtyp</label>
    <app-hint>
      <b>Vektor:</b> Semantische Suche über KI-Embeddings – findet inhaltlich Ähnliches auch ohne exakte Stichwörter.
      Schnellste Methode.<br><br>
      <b>Volltext:</b> Keyword-Suche mit Fuzzy-Matching – treffsicher bei exakten Begriffen, kein semantisches
      Verständnis. Langsamer als Vektor.<br><br>
      <b>Kombiniert:</b> Vereint beide Methoden für beste Ergebnisqualität – am langsamsten.<br><br>
      Empfehlung: Ausprobieren, welche Methode für deinen Bot die besten Ergebnisse liefert.
    </app-hint>
  </div>
  <div class="col">
    <p-select
      [options]="searchTypeOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="safeSearchType"
      (ngModelChange)="saveDocument()"
      fluid
    ></p-select>
  </div>
</div>
<div class="row mt-3 align-items-center">
  <div class="col-3">
    <span i18n="@@doc-search-memory">Ergebnisse früherer Suchen merken</span>
    <app-hint i18n="@@hint-doc-search-memory-per-doc">
      Merkt sich Ergebnisse vergangener Suchen über dieses Dokument im Gespräch, damit Wissen aus früheren
      Suchen bei späteren Nachrichten erhalten bleibt.
    </app-hint>
  </div>
  <div class="col-auto">
    <p-toggleswitch
      [(ngModel)]="this.rss.document.docSearchMemoryEnabled"
      (ngModelChange)="this.saveDocument()"
    ></p-toggleswitch>
  </div>
  @if (this.rss.document.docSearchMemoryEnabled) {
  <div class="col-3">
    <label
      class="form-label"
      i18n="@@doc-search-memory-limit"
    >Anzahl gemerkter Suchen</label>
    <app-hint i18n="@@doc-search-memory-limit-hint">Ältere Suchen werden nicht verworfen, sondern automatisch
      zusammengefasst.</app-hint>
    <p-inputnumber
      [(ngModel)]="this.safeDocSearchMemoryLimit"
      [min]="1"
      [max]="10"
      [showButtons]="true"
      (ngModelChange)="this.saveDocument()"
    ></p-inputnumber>
  </div>
  }
</div>
}
@if (!this.rss.document.mimetype.startsWith('image/')) {
<p-inputgroup class="mt-3">
  <input
    pInputText
    #enumTestString
    [disabled]="this.searchTestService.searchTestIsRunning"
    fluid
  />
  <p-button
    severity="primary"
    [style]="{ 'border-top-left-radius': '0', 'border-bottom-left-radius': '0' }"
    (onClick)="this.searchTestService.searchTest(enumTestString.value)"
    [disabled]="this.searchTestService.searchTestIsRunning"
    label="Suchanfrage testen"
    i18n-label="@@test-search-phrase"
  />
</p-inputgroup>
<div class="mt-3">
  @if (this.searchTestService.searchTestCompleted && this.searchTestService.searchTestResults.length === 0) {
  <div class="row mt-2">
    <div class="col col-auto">
      <p-message
        severity="warn"
        [closable]="false"
      >
        <span i18n="@@no-search-results">Keine Ergebnisse gefunden.</span>
      </p-message>
    </div>
  </div>
  }
  @if (this.searchTestService.searchTestCompleted && this.searchTestService.searchTestResults.length > 0) {
  <div class="row mt-2">
    <div class="col">
      <p-table
        [value]="this.searchTestService.searchTestResults"
        [rowHover]="true"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Score</th>
            <th>Seiten</th>
            <th i18n="@@search-test-chapter-column">Kapitel</th>
            <th>Inhalt</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-testResult
        >
          <tr>
            <td>{{ testResult.chunk.vs_score * 100 | number:"2.2-2" }}%</td>
            <td>
              @if(testResult.chunk.first_page === testResult.chunk.last_page) {
              {{ testResult.chunk.first_page }}
              } @else {
              {{ testResult.chunk.first_page }} - {{ testResult.chunk.last_page }}
              }
            </td>
            <td>{{ testResult.chunk.chapterPath ?? '–' }}</td>
            <td>{{ testResult.chunk.content }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  }
</div>
<p-accordion
  class="mt-3"
  [value]="['0']"
>
  <p-accordion-panel value="0">
    <p-accordion-header>
      <div class="col">
        <i class="ri-file-text-fill me-2"></i>
        <span i18n="@@document-view"><b>textbasierte Dokumentenvorschau (KI-optimiert)</b></span>
      </div>
    </p-accordion-header>
    <p-accordion-content>
      <p-table
        [value]="documentChunks"
        [rowHover]="true"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Seiten</th>
            <th>Inhalt</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-chunk
        >
          <tr>
            <td>
              @if(chunk.first_page === chunk.last_page) {
              {{ chunk.first_page }}
              } @else {
              {{ chunk.first_page }} - {{ chunk.last_page }}
              }
            </td>
            <td>{{ chunk.content }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
}
}